<template>
  <div ref="rootA4">
    <div ref="simppage" v-if="preload" class="ssimplexpage">
      <paperHeader
        id="paper-header"
        :perperName="paperName"
        :college="college"
        :marjor="marjor"
        :className="className"
        :studentName="studentName"
        :studentNumber="studentNumber"
        :questionMark="questionTitle"
      ></paperHeader>
      <div v-for="(qarray, aid) in questionArray" :key="aid">
        <p class="qarraytitle" :id="'paper-array-title-' + qarray.qtype">
          {{ qarray.title }}
        </p>
        <questionRender
          v-for="(qitem, qid) in qarray.questions"
          :key="qid"
          :question="qitem"
        ></questionRender>
      </div>
    </div>
    <div v-else ref="signalroot" class="srootcanvas"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import { getWatermark } from "@/util/warterMark";
import paperHeader from "./PaperHeader.vue";
import questionRender from "./QuestionRender.vue";
import { convertToQustionEntity } from "@/util/extraction.js";
export default {
  name: "PreView4",
  mounted() {
    this.initProps();
  },
  props: {
    paperData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    paperHeader,
    questionRender
  },
  data: function() {
    return {
      preload: true,
      paperName: "",
      college: "",
      marjor: "",
      className: "",
      studentName: "",
      studentNumber: "",
      questionArray: [],
      questionTitle: [],
      paperheadnode: null,
      paperquestionnodes: [],
      watermark: ""
    };
  },
  methods: {
    initProps() {
      this.paperName = this.paperData.examName;
      this.college = this.paperData.collegename;
      this.marjor = this.paperData.majorName;
      this.className = this.paperData.className;
      this.studentName = this.paperData.userName;
      this.studentNumber = this.paperData.userNo;

      this.setWaterMark(this.paperData.collegename);
      const tids = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      let questiondic = new Map();
      // 使用 questions 初始化 questiondic 以获取总分（满分）
      this.paperData.questions.forEach(val => {
        if (!questiondic.has(val.qtype)) {
          questiondic.set(val.qtype, {
            Title: this.getQTypeTitle(val.qtype),
            Num: 1,
            totalScore: val.score || 0,
            studentScore: 0
          });
        } else {
          let dicitem = questiondic.get(val.qtype);
          dicitem.Num = dicitem.Num + 1;
          dicitem.totalScore = dicitem.totalScore + (val.score || 0);
        }
      });

      //题目
      let fltenity = [];
      this.paperData.questions.forEach(elment => {
        let nquestion = convertToQustionEntity(elment);
        let answer = this.paperData.answers.find(
          aitem => aitem.question_table_item_id === elment.id
        );
        let earnedScore = 0;
        if (answer) {
          nquestion.setUserChoice(answer.userChoice);
          // 计算单题得分
          earnedScore = this.calculateQuestionEarnedScore(elment, answer);
        }
        nquestion.earnedScore = earnedScore; // 存储实得分
        fltenity.push(nquestion);

        // 累加实得分到汇总表字典
        if (questiondic.has(elment.qtype)) {
          let dicitem = questiondic.get(elment.qtype);
          dicitem.studentScore += earnedScore;
        }
      });

      let tId = 0;
      this.questionArray = [];
      this.questionTitle = [];
      questiondic.forEach((val, key) => {
        let fltq = fltenity.filter(fq => fq.qtype === key);
        fltq.map((x, index) => (x.index = index + 1));
        let qarray = {};
        qarray.qtype = key;
        qarray.totalScore = val.totalScore;

        // 优先使用后端传回的分类实得分
        let backendScore = null;
        if (key === "SingX") backendScore = this.paperData.score;
        else if (key === "MultX") backendScore = this.paperData.multiScore;
        else if (key === "JudgX") backendScore = this.paperData.judgeScore;
        else if (key === "FillX") backendScore = this.paperData.fillXScore;
        else if (key === "AnwsX") backendScore = this.paperData.anwsXScore;
        else if (key === "ProofX") backendScore = this.paperData.proofXScore;

        qarray.studentScore =
          backendScore !== undefined && backendScore !== null
            ? backendScore
            : val.studentScore;

        qarray.title =
          tids[tId] +
          "、" +
          val.Title +
          "(共" +
          val.Num +
          "小题" +
          val.totalScore +
          "分)";
        tId++;
        qarray.questions = fltq;
        this.questionArray.push(qarray);
      });

      // 定义固定的题型顺序
      const orderMap = {
        SingX: 1,
        MultX: 2,
        JudgX: 3,
        FillX: 4,
        ProofX: 5,
        AnwsX: 6,
        ZgzhX: 7
      };

      // 按固定顺序对 questionArray 进行排序
      this.questionArray.sort((a, b) => {
        const orderA = orderMap[a.qtype] || 99;
        const orderB = orderMap[b.qtype] || 99;
        return orderA - orderB;
      });

      // 根据排序后的题目数组生成题号标题和得分表
      this.questionTitle = [];
      this.questionArray.forEach((qarray, index) => {
        // 对于特定题型，内部题目按 ID 排序
        if (["FillX", "ProofX", "AnwsX", "ZgzhX"].includes(qarray.qtype)) {
          qarray.questions.sort((a, b) => a.id - b.id);
        }

        // 重新生成题目序号标题 (一、二、...) - 显示满分
        qarray.title =
          tids[index] +
          "、" +
          this.getQTypeTitle(qarray.qtype) +
          "(共" +
          qarray.questions.length +
          "小题" +
          qarray.totalScore +
          "分)";

        // 生成对应的得分表项 - 显示阶段得分汇总之和（实得分）
        let qtitle = {
          qtype: qarray.qtype,
          qtitle: this.getQTypeTitle(qarray.qtype),
          qscore: qarray.studentScore.toFixed(2).replace(/\.00$/, "")
        };
        this.questionTitle.push(qtitle);
      });

      let totalqtile = {};
      totalqtile.qscore = this.paperData.totalScore.toString();
      totalqtile.qtitle = "总分";
      this.questionTitle.push(totalqtile);
    },
    /**
     * 计算单题实得分
     */
    calculateQuestionEarnedScore(question, answer) {
      if (!answer) return 0;
      const qtype = question.qtype;
      const userChoice = (answer.userChoice || "").trim();
      const correctOrder = (answer.correctOrder || "").trim();
      const fullScore = question.score || 0;

      if (qtype === "SingX") {
        return userChoice === correctOrder ? fullScore : 0;
      }

      if (qtype === "JudgX") {
        if (userChoice === correctOrder && correctOrder !== "") {
          return fullScore;
        }
        return 0;
      }

      if (qtype === "MultX") {
        if (!userChoice || !correctOrder) return 0;
        const uList = userChoice
          .split(",")
          .map(s => s.trim())
          .filter(s => s)
          .sort();
        const cList = correctOrder
          .split(",")
          .map(s => s.trim())
          .filter(s => s)
          .sort();

        const isEqual =
          uList.length === cList.length &&
          uList.every((v, i) => v === cList[i]);
        if (isEqual) return fullScore;

        // 不定项按比例给分逻辑 (对齐后端 HALF_UP 逻辑)
        if (this.paperData.isOpenMultiChoice == 1) {
          const cSet = new Set(cList);
          const isSubset = uList.length > 0 && uList.every(v => cSet.has(v));
          if (isSubset) {
            // 后端逻辑：(new BigDecimal(tList.size())).divide(new BigDecimal(eList.size()), 2, RoundingMode.HALF_UP)
            let rate = Math.round((uList.length / cList.length) * 100) / 100;
            // 然后 multiply(score).setScale(2, RoundingMode.HALF_UP)
            return Math.round(rate * fullScore * 100) / 100;
          }
        }
        return 0;
      }

      // 主观题处理：0-错误，1-正确，2-半倍分
      if (["FillX", "AnwsX", "ProofX", "ZgzhX"].includes(qtype)) {
        if (userChoice === "0") return 0;
        if (userChoice === "1") return fullScore;
        if (userChoice === "2") return fullScore / 2;
      }

      return 0;
    },
    async onHomeRecvPaper() {
      await this.$nextTick();
      await this.$nextTick();
      await this.$nextTick();
      return true;
    },
    setWaterMark(txt) {
      this.watermark = getWatermark(txt);
      const simppage = this.$refs.rootA4;
      if (simppage != null) {
        simppage.style.background = this.watermark;
        simppage.style.backgroundColor = "#ffffff";
        simppage.style.minHeight = "100vh"; // Ensure full height
      }
    },
    delayTime(tm) {
      return new Promise(res => {
        setTimeout(() => {
          res();
        }, tm);
      });
    },
    createSpaceDiv() {
      let splitbox = document.createElement("div");
      splitbox.style.display = "block";
      splitbox.style.margin = "0px";
      splitbox.style.padding = "0px";
      splitbox.style.height = "20px";
      splitbox.style.width = "100px";
      return splitbox;
    },
    createChildItem(pageindx) {
      let spage = null;
      const sigroot = this.$refs.signalroot;
      if (sigroot != null) {
        let splitbox = document.createElement("div");
        if (pageindx == 0) {
          splitbox.className = "ssplitbarfirst";
        } else {
          splitbox.className = "ssplitbar";
        }
        sigroot.appendChild(splitbox);
        //
        spage = document.createElement("div");
        spage.className = "spage";
        spage.style.background = this.watermark;
        spage.style.backgroundColor = "#ffffff";
        spage.style.padding = "40px 80px";
        spage.style.boxSizing = "border-box";
        sigroot.appendChild(spage);
      }
      return spage;
    },
    cloneNodes() {
      let elementid = "paper-header";
      let headnode = document.getElementById(elementid);
      this.paperheadnode = null;
      if (headnode != null) {
        let hnode = {
          node: headnode.cloneNode(true),
          hg: Math.ceil(parseFloat(getComputedStyle(headnode, null).height)),
          ename: elementid
        };
        this.paperheadnode = hnode;
      }
      this.paperquestionnodes = [];
      this.questionArray.forEach(qarray => {
        elementid = "paper-array-title-" + qarray.qtype;
        let qarraynode = document.getElementById(elementid);
        if (qarraynode != null) {
          let hnode = {
            node: qarraynode.cloneNode(true),
            hg: Math.ceil(
              parseFloat(getComputedStyle(qarraynode, null).height)
            ),
            ename: elementid
          };
          this.paperquestionnodes.push(hnode);
        }
        qarray.questions.forEach(question => {
          //题干
          for (let idx = 0; idx < question.steamjs.length; idx++) {
            elementid = question.id + "_stem_" + idx;
            let qstemnode = document.getElementById(elementid);
            if (qstemnode != null) {
              let hnode = {
                node: qstemnode.cloneNode(true),
                hg: Math.ceil(
                  parseFloat(getComputedStyle(qstemnode, null).height)
                ),
                ename: elementid
              };
              this.paperquestionnodes.push(hnode);
            }
          }
          //选项
          for (let idx = 0; idx < question.optionsjs.length; idx++) {
            let ops = question.optionsjs[idx];
            for (let rdx = 0; rdx < ops.ranginfos.length; rdx++) {
              elementid = question.id + "_option_" + idx + "_" + rdx;
              let qoptnode = document.getElementById(elementid);
              if (qoptnode != null) {
                let hnode = {
                  node: qoptnode.cloneNode(true),
                  hg: Math.ceil(
                    parseFloat(getComputedStyle(qoptnode, null).height)
                  ),
                  ename: elementid
                };

                this.paperquestionnodes.push(hnode);
              }
            }
          }
          //答案
          for (let idx = 0; idx < question.answerjs.length; idx++) {
            elementid = question.id + "_answer_" + idx;
            let qanswernode = document.getElementById(elementid);
            if (qanswernode != null) {
              let hnode = {
                node: qanswernode.cloneNode(true),
                hg: Math.ceil(
                  parseFloat(getComputedStyle(qanswernode, null).height)
                ),
                ename: elementid
              };
              this.paperquestionnodes.push(hnode);
            }
          }
          //解析
          for (let idx = 0; idx < question.solvejs.length; idx++) {
            elementid = question.id + "_slove_" + idx;
            let qsolvenode = document.getElementById(elementid);
            if (qsolvenode != null) {
              let hnode = {
                node: qsolvenode.cloneNode(true),
                hg: Math.ceil(
                  parseFloat(getComputedStyle(qsolvenode, null).height)
                ),
                ename: elementid
              };
              this.paperquestionnodes.push(hnode);
            }
          }
        });
      });
    },
    //移除题目
    moveQuestions() {
      let pagehg = 1055.0;
      let pageindex = 0;
      let pg = this.createChildItem(pageindex);
      if (this.paperheadnode != null) {
        pagehg = pagehg - this.paperheadnode.hg;
        pg.appendChild(this.paperheadnode.node);
      }

      for (let n = 0; n < this.paperquestionnodes.length; n++) {
        let qitemnode = this.paperquestionnodes[n];
        let elementshowhg = qitemnode.hg;
        if (pagehg < elementshowhg) {
          //换页
          pageindex++;
          pg = this.createChildItem(pageindex);
          pagehg = 1065.0;

          pg.appendChild(qitemnode.node);
          pagehg = pagehg - elementshowhg;
          let splitbox = this.createSpaceDiv();
          pg.appendChild(splitbox);
          pagehg = pagehg - 20;
        } else {
          pg.appendChild(qitemnode.node);
          pagehg = pagehg - elementshowhg;
          if (pagehg > 20) {
            let splitbox = this.createSpaceDiv();
            pg.appendChild(splitbox);
            pagehg = pagehg - 20;
          }
        }
      }
      //
      pg.style.height = "1080px";
    },
    fixitemHeight(qnode) {
      let headnode = document.getElementById(qnode);
      let chg = getComputedStyle(headnode, null);
      console.log(headnode);
      console.log(headnode.offsetHeight);
      console.log(chg);
      return false;
    },
    getQTypeTitle(qtype) {
      switch (qtype) {
        case "SingX":
          return "单选题";
        case "MultX":
          return "多选题";
        case "JudgX":
          return "判断题";
        case "FillX":
          return "填空题";
        case "AnwsX":
          return "解答题";
        case "ProofX":
          return "证明题";
        case "ZgzhX":
          return "综合题";
        default:
          return "其他";
      }
    }
  }
};
</script>
<style scoped lang="scss">
.srootcanvas {
  width: 100%;
  display: block;
}

.qarraytitle {
  display: block;
  text-align: left;
  padding-left: 0; // Removed padding to align left
  margin: 20px 0px 15px 0px;
  font-size: 18px; // Standard section title size
  font-weight: 700; // Bold
  font-family: "SimHei", "Heiti SC", sans-serif; // Bold Heiti font
  color: #000;
  page-break-inside: avoid !important;
}

.ssimplexpage {
  display: block;
  font-size: 18px;
  font-family: "SimSun", "Songti SC", serif;
  padding: 40px 80px;
  box-sizing: border-box;
  background-color: #ffffff;
}
</style>
